//изображение бэкграундом
function ibg() {
  let ibg = document.querySelectorAll(".ibg");
  for (let i = 0; i < ibg.length; i++) {
    if (ibg[i].querySelector("img")) {
      ibg[i].style.backgroundImage =
        "url(" + ibg[i].querySelector("img").getAttribute("src") + ")";
    }
  }
}

ibg();

// BTN LOAD MORE
let offsetArticles;
let containerForBtnArticles = document.querySelector("#more_articles");
let btnArticleLoadMore = document.querySelector("#btn_more_articles");

if (typeof btnArticleLoadMore != "undefined" && btnArticleLoadMore != null) {
  btnArticleLoadMore.addEventListener("click", function () {
    offsetArticles = btnArticleLoadMore.getAttribute("data-offset");
    let dataProduct = btnArticleLoadMore.getAttribute("data-product");
    let dataCategory = btnArticleLoadMore.getAttribute("data-category");
    let dataUrl = btnArticleLoadMore.getAttribute("data-url");
    getDataArticles(offsetArticles, dataProduct, dataCategory, dataUrl);
  });
}

function getDataArticles(offset, product, category, urlRequest) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params =
    "offset=" +
    offset +
    "&product=" +
    product +
    "&category=" +
    category +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        document.querySelector(".items-block.articles").insertAdjacentHTML( 'beforeend', response.html );
        if (
          response.showLoadMore === false ||
          response.showLoadMore === "false"
        ) {
          containerForBtnArticles.classList.add("hide");
        } else {
          console.log("get offset response", response.offset);
          btnArticleLoadMore.setAttribute("data-offset", response.offset);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
